/**
 *
 * @notice DocumentoModalSlice to handle state of DocumentoModal globally.
 *
 * @dev This module contains the reducer configuration and its initialization.
 * @dev Is the sucker wich contains features of this slice.
 *
 */

// Redux.
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
// Axios.
import axios from "axios"
// gmapi.
import { API_KEY, caricaDocumentoAPI } from "../../../../common/gmApi"
// cookie.
import { tkbox, getCookie } from "../../../../common/cookie"

/********************************************
 *                                          *
 * @notice AsyncThunk API(s) Implementation *
 *                                          *
 ********************************************/

/**
 *
 *  @dev Upload a new documento.
 *
 */
export const uploadDocumento = createAsyncThunk(
    "documento/uploadDocumento",
    async ({ organicoId, data, scadenza, titoloDocumento, tipoDocumento, allegato, note }, thunkAPI) => {
        try {
            var bodyFormData = new FormData()
            bodyFormData.append('allegato', allegato, allegato.name)

            const response = await axios.post(
                // url.
                caricaDocumentoAPI,
                // body.
                bodyFormData,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        organicoId: organicoId,
                        data: data,
                        scadenza: scadenza,
                        titoloDocumento: titoloDocumento,
                        tipoDocumento: tipoDocumento,
                        note: note
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    //return console.log(response.data);
                    return response.data
                } else {
                    // else reject gmapi response error.
                    //console.error('Error "showEmployeeCourseDocById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "uploadDocumento":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            // If something get wrong then reject the error.
            console.error('Error "uploadDocumento":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

/*******************************************
 *                                         *
 * @notice createSlice implementation.     *
 *                                         *
 * @dev Create a "documentoModalSlice" feature. *
 * @dev UI views state controller.         *
 *                                         *
 *******************************************/
export const documentoModalSlice = createSlice({
    name: "documentoModal",
    initialState: {
        modalIsOpen: false,     // Modal is open or not.
        modalIsFetching: false, // AsyncThunk is calling an API.
        modalIsSuccess: false,  // AsyncThunk is success from API call.
        modalIsError: false,    // AsyncThunk is fail from API call.
        modalErrorMsg: "",      // Error message container.
    },
    reducers: {
        clearState: (state) => {
            state.modalIsError = false
            state.modalIsSuccess = false
            state.modalIsFetching = false

            return state
        },
        openModal: (state) => {
            state.modalIsOpen = true
        },
        closeModal: (state) => {
            state.modalIsOpen = false
        },
    },
    extraReducers: (builder) => {
        builder
            /**
             * @dev uploadDocumento.
             */
            .addCase(uploadDocumento.fulfilled, (state) => {
                state.modalIsFetching = false
                state.modalIsSuccess = true
            })
            .addCase(uploadDocumento.pending, (state) => {
                state.modalIsFetching = true
            })
            .addCase(uploadDocumento.rejected, (state, action) => {
                state.modalIsFetching = false
                state.modalIsError = true
                state.modalErrorMsg = action.payload
            })
    },
})

export const { clearState, openModal, closeModal } = documentoModalSlice.actions
export const documentoModalSelector = (state) => state.documentoModal